import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import PageLoader, { ScrollProgress } from "./components/PageLoader";

/* Code-splitting: each route ships as its own chunk, so visiting the
   homepage no longer downloads the Services and About pages too. */
const Home = lazy(() => import("./routes/Home"));
const Services = lazy(() => import("./routes/Services"));
const About = lazy(() => import("./routes/About"));
const Contact = lazy(() => import("./routes/Contact"));

function App() {
  return (
    <div className="App">
      <ScrollProgress />
      <Navbar />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
